export const API_NAME = 'supply-exp';
